import { RootState } from 'src/store';

const getPolicyDetailsState = (state: RootState) => state.policyDetails;

export const getPolicySections = (state: RootState) =>
  getPolicyDetailsState(state)?.sections || [];

export const getPolicyDetailsLoading = (state: RootState) =>
  getPolicyDetailsState(state)?.status?.loading;

export const getPolicyDetailsError = (state: RootState) =>
  getPolicyDetailsState(state)?.status?.error || '';
